export const regularFontFamily = (weight = 'regular') => {
  let css = 'font-family: Montserrat, Helvetica, Arial, sans-serif;'
  switch(weight) {
    case 'light':
      css += 'font-weight: 200;';
      break;
    case 'bold':
      css += 'font-weight: 700;';
      break;
    default:
      css += 'font-weight: 400;';
  }
  return css
}

export const heavyFontFamily = (weight = 'bold') => {
  let css = 'font-family: Arvo, Helvetica, Arial, sans-serif;'
  switch(weight) {
    case 'regular':
      css += 'font-weight: 400;';
      break;
    default:
      css += 'font-weight: 700;';
  }
  return css
}

export const mediumMediaQuery = () => (
  '@media (min-width: 768px)'
)

export const largeMediaQuery = () => (
  '@media (min-width: 1024px)'
)



// WEBPACK FOOTER //
// ./src/utils/style-helpers.js